import {
  CircleCheckBigIcon,
  FileTextIcon,
  TagIcon,
  TagsIcon,
  UserIcon,
  CarIcon,
} from "lucide-react";

import {
  filterVisibleVehicleAssignmentDefinitions,
  type VehicleAssignmentFlowContext,
  type VehicleAssignmentStepDefinition,
} from "@/lib/cat/vehicle-assignment-step-definitions";

const avsStepDefinitions: VehicleAssignmentStepDefinition[] = [
  {
    description: "Identification",
    icon: CarIcon,
    id: "vehicle_identification",
    title: "Véhicule",
  },
  {
    description: "Canal de vente",
    icon: TagsIcon,
    id: "sales_channels",
    title: "Canal de vente",
  },
  {
    description: "Particulier/Société",
    icon: UserIcon,
    id: "client",
    title: "Client",
    // TODO: must be conditional when fleet + selected sales channel = false
    when: (ctx) => true,
  },
  {
    description: "Type de vente",
    icon: TagIcon,
    id: "selling_type_avs",
    title: "Type de vente",
  },
  {
    description: "Informations",
    icon: FileTextIcon,
    id: "additional_informations",
    title: "Informations complémentaires",
  },
  {
    description: "Récapitulatif & validation CTM",
    icon: CircleCheckBigIcon,
    id: "ctm_summary_validation",
    title: "Récapitulatif & validation CTM",
  },
];

function getAvsVehicleAssignmentVisibleDefinitions(
  ctx: VehicleAssignmentFlowContext,
): VehicleAssignmentStepDefinition[] {
  return filterVisibleVehicleAssignmentDefinitions(avsStepDefinitions, ctx);
}

export { avsStepDefinitions, getAvsVehicleAssignmentVisibleDefinitions };
